module.exports = __webpack_public_path__ + "img/box4-normal2.a574aa60.png";